import { render, staticRenderFns } from "./SaveQuoteFormSkeleton.vue?vue&type=template&id=0b02f214&"
import script from "./SaveQuoteFormSkeleton.vue?vue&type=script&lang=js&"
export * from "./SaveQuoteFormSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports